<template>
  <v-badge
    color="success"
    offset-x="20"
    offset-y="20"
    class="mr-1"
    :content="prints.length"
    :value="prints.length"
  >
    <template v-slot:badge>
      <span class="small-text">{{ prints.length }}</span>
    </template>
    <!-- :disabled="!prints.length" -->
    <v-btn
      icon
      :color="prints.length ? 'donateback' : 'grey'"
      to="/prints"
    >
      <v-icon>
        fa-print
      </v-icon>
    </v-btn>
  </v-badge>
</template>

<script>
import { mapGetters } from "vuex"
import { db } from '@/plugins/firebase'
import { collection, onSnapshot, query, orderBy, where, doc, updateDoc } from "firebase/firestore"
import imprimir from '@/functions/SetPrint'

export default {
  name: 'PrinterBtn',
  data: () => ({
    prints: [],
    suscribePrints: null,
    flag: false
  }),
  created () {
    this.getPrints()
  },
  computed : {
    ...mapGetters(["negocio"]),
  },
  beforeDestroy () {
    if (this.suscribePrints) {
      this.suscribePrints()
    }
  },
  methods: {
    async getPrints() {
      try {
        const queryData = query(collection(db, "prints"),
          where("state","==", 'Nueva'),
          where("deleted","==", false),
          orderBy("date","desc"))
        this.suscribePrints = await onSnapshot(queryData, (querySnapshot) => {
          this.prints = []
          querySnapshot.docChanges().forEach((document) => {
            if (document.type === "added") {
              this.prints.push({id:document.doc.id, ...document.doc.data()})
            }
          })
          this.sendToPrint(this.prints[0])
        },(error) => {
          console.error('Hay un error en el listinig del onSnapshot')
          console.error(error)
        })
      } catch (error) {
        console.error('error -> ', error.message)
        this.prints = []
      }
    },
    async sendToPrint(data) {
      if (data) {
        let numPrint = 0
        if (data.origin === 'ArqueoCaja') {
          data.dataPost.impresora = this.negocio.impresoraAdmin
          numPrint = 1
        }
        if (data.origin === 'CuentaOrden') {
          data.dataPost.impresora = this.negocio.impresoraAdmin
          numPrint = 1
        }
        if (data.origin === 'PagoComprobante') {
          data.dataPost.impresora = this.negocio.impresoraAdmin
          // numPrint = this.negocio.numeroImpresionComprobantes ? this.negocio.numeroImpresionComprobantes : 1
          numPrint = 1
        }
        if (data.origin === 'TakeComandaCocina') {
          data.dataPost.impresora = this.negocio.impresoraCocina
          numPrint = this.negocio.numeroImpresionComandasCocina ? this.negocio.numeroImpresionComandasCocina : 1
        }
        if (data.origin === 'TakeComandaBar') {
          data.dataPost.impresora = this.negocio.impresoraBar
          numPrint = this.negocio.numeroImpresionComandasBar ? this.negocio.numeroImpresionComandasBar : 1
        }
        if (data.origin === 'TakeOrden') {
          data.dataPost.impresora = this.negocio.impresoraOrden
          numPrint = this.negocio.numeroImpresionOrden ? this.negocio.numeroImpresionOrden : 1
        }
        if (numPrint > 0) {
          const promesas = []
          for (let index = 0; index < numPrint; index++) {
            data.dataPost.id+=index.toString();
            if (this.negocio.usePrinterPi) {
              promesas.push(imprimir.printDocumentPi(data.service, data.dataPost, data.title, this.negocio.serverPi))
            } else {
              promesas.push(imprimir.printDocument(data.service, data.dataPost))
            }
            // console.info('Se encola impresión: ',index, data.dataPost.id, data.origin)
          }
          await Promise.all(promesas)
        }
        await updateDoc(doc(db, 'prints', data.id), {
          state: 'Impresa'
        })
      }
    }
  }
}
</script>
<style>
</style>
